import { createApp } from 'vue';
import SimpleApp from './SimpleApp.vue';
import '../style.css';

const app = createApp(SimpleApp);

app.config.errorHandler = (error, instance, info) => {
  console.error('[Vue simple app error]', error.message, info);
  if (error.stack) console.error(error.stack.split('\n').slice(0, 6).join('\n'));
};

app.mount('#simple-app');
